import {
  Icon,
  MetricsCard,
  SkeletonWrapper,
} from "@humanpredictiveintelligence/myqvt-library"
import React from "react"
import { useTheme } from "styled-components"
import * as Styles from "./PimeoMetric.styles"

export const PimeoMetric: React.FC<PimeoMetricProps> = ({ title, sections, isLoading }) => {
  const theme = useTheme()

  return (
    <MetricsCard title={title} hasReducedPadding>
      <Styles.Container>
        {sections.map((metrics, index) => (
          <Styles.Column key={index}>
            {metrics.map(metric => (
              <Styles.Metric>
                <Icon name={metric.icon} color={theme.colors.primary}/>
                <SkeletonWrapper isLoading={isLoading} width={100} height={20}>
                  {metric.content}
                </SkeletonWrapper>
              </Styles.Metric>
            ))}
          </Styles.Column>
        ))}
      </Styles.Container>
    </MetricsCard>
  )
}

type Section = [ Metric ] | [ Metric, Metric ]

interface Metric {
  icon: string,
  content: JSX.Element,
}

interface PimeoMetricProps {
  title: string,
  sections: [ Section, Section ],
  isLoading?: boolean,
}
